import { generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from '@types'

export const rxDrugCardGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'rxDrugCard'

  return {
    prescriptiondrugcard_print_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.PrescriptionDrugCard,
        elementId: 'prescriptiondrugcard_print_click',
        coreClickData: {
          linkText: i18n.t('printButton', { ns })
        }
      }
    }
  } // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type RxDrugCardKeys = keyof ReturnType<typeof rxDrugCardGenerator>

export default rxDrugCardGenerator
